import { permissionMenuRoutes, asyncRouterMap as asyncRouterMapRoot, processedDefaultMenus } from '@/routes'
import treeUtils from '@/utils/treeUtils'
import _ from 'lodash'
import { nanoid } from 'nanoid'
/**
 *
 * @param {*} apiMenus 接口返回的menu
 * @returns 基于route的menuData
 */
function generateMenuData(apiMenus) {
  let menuData = treeUtils.map(apiMenus, item => {
    let standarPath = ''
    if (item.menuUrl) {
      // menuUrl需要以 '/' 开头
      if (!item.menuUrl.startsWith('/')) {
        standarPath += '/'
      }
      standarPath += item.menuUrl
    } else {
      const uniq = item.authId || nanoid(8)
      standarPath = `/m/__NO_PATH_${uniq}__`
    }
    const actions = []
    if (item.children) {
      item.children.map(child => {
        if (child.menuType === 'A') {
          actions.push({
            name: child.menuName,
            code: child.menuCode,
          })
        }
      })
      // 指定哪些菜单为目录（需要重定向的）
      if (item.children.some(child => child.menuType === 'C')) {
        item.menuType = 'M'
      }
    }
    return {
      path: standarPath,
      meta: {
        title: item.menuName,
        icon: item.menuIcon,
        type: item.menuType,
        actions,
      },
    }
  })
  menuData = treeUtils.filter(menuData, item => {
    return item.menuType !== 'A'
  })
  return menuData
}
/**
 * 创建用户的menu,并用预设的前端menu补充信息
 * 本地路由集中有的，但远程菜单没有的，会自动添加hidden
 * @param {*} localRouteMap 本地路由集
 * @param {*} menu 用户菜单
 */
function generateMenu(localRouteMap, menu, modules) {
  const r = {}
  treeUtils.map(localRouteMap, route => {
    if (route.path) {
      r[route.path] = {
        ...route,
      }
    }
  })
  // 补全menu信息(只循环menu)
  let resultMenus = treeUtils.map(menu, m => {
    const menuMeta = m.meta
    for (const j in menuMeta) {
      // defaultsDeep null 和 '' 无法被覆盖
      if (menuMeta[j] === '' || menuMeta[j] === null) {
        delete menuMeta[j]
      }
    }
    const localRoute = r[m.path]
    localRoute
    if (localRoute) {
      _.defaultsDeep(m, localRoute)
    }
    return m
  })
  // 添加menu下的子路由（只循环menu）
  treeUtils.map(_.cloneDeep(resultMenus), (m, indexId) => {
    const localRoute = r[m.path]
    if (localRoute) {
      const route = treeUtils.findByIndexId(resultMenus, indexId)
      if (localRoute.children) {
        const children = treeUtils.map(localRoute.children, child => {
          child.meta.hidden = true
        })
        route.children = children
      }
    }
  })
  // 补全redirect和component(循环menu 和添加的 子路由)
  resultMenus = treeUtils.map(resultMenus, r => {
    if (r.meta.type === 'M' && !r.redirect) {
      const activeChild = r.children?.find(routeChild => !routeChild.meta.hidden)
      if (activeChild) {
        r.redirect = activeChild.path
      }
    }
    if (!(r.component || r.redirect)) {
      r.component = () => import('@/pages/exception/404')
    }
  })
  return resultMenus
}
function generateAccessRouters(menus, routerMap) {
  const accessRouters = []
  let blankAccessRouters = []
  const rootPermissionRouters = routerMap.find(v => v.path === '/m')
  const rootBlankPermissionRoutes = routerMap.find(v => v.path === '/b')

  treeUtils.map(menus, route => {
    const { children, ...r } = route
    if (r.path) {
      const isInAcessRouters = accessRouters.find(item => item.path === r.path)
      if (!isInAcessRouters) {
        accessRouters.push(r)
      }
    }
  })
  const accessRoutersCopy = _.cloneDeep(accessRouters)
  blankAccessRouters = treeUtils.map(accessRoutersCopy, route => {
    route.path = `/b${route.path}`
    if (route.redirect) {
      route.redirect = `/b${route.redirect}`
    }
  })

  rootPermissionRouters.children = accessRouters
  rootBlankPermissionRoutes.children = blankAccessRouters
  return routerMap
}
const permission = {
  state: {
    asyncRouterMap: [],
    menus: [],
    modules: [], // modules 暂时没用
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.asyncRouterMap = routers
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    RESET_PERMISSION(state) {
      state.asyncRouterMap = []
      state.menus = []
      state.modules = []
    },
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data
        // menuData 只包含menu数据
        const menuData = generateMenuData(roles.permissions.menus)
        // 基于menuData 创建完整的routes 包含 redirect / component / meta
        const processedPermissionMenus = generateMenu(permissionMenuRoutes, menuData, roles.permissions.modules)
        // processedMenus 是完整的菜单
        const processedMenus = processedDefaultMenus.concat(processedPermissionMenus)
        // 基于菜单创建真正的路由
        const accessRouters = generateAccessRouters(processedMenus, asyncRouterMapRoot)
        const asyncRouterMap = [
          ...accessRouters,
          // 一个菜单都没有，重定向到403
          {
            path: '/',
            redirect: processedMenus[0] ? processedMenus[0].path : '/403',
          },
          {
            path: '*',
            redirect: '/404',
          },
        ]
        commit('SET_MENUS', processedMenus)
        commit('SET_ROUTERS', asyncRouterMap)
        resolve()
      })
    },
  },
}

export default permission
